"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalIsNative = exports.newTotal = exports.isTotal = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var measure_1 = require("../measure");
var attribute_1 = require("../attribute");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
//
// Type guards
//
/**
 * Type-guard checking whether an object is a Total.
 *
 * @public
 */
function isTotal(obj) {
    return !isEmpty_1.default(obj) && obj.type !== undefined;
}
exports.isTotal = isTotal;
//
//
//
/**
 * Creates a new total.
 *
 * @param type - type of total, one of the enumerated types
 * @param measureOrId - measure instance OR measure local identifier
 * @param attributeOrId - attribute instance OR attribute local identifier
 * @param alias - optionally provide custom name (alias) for the total; this will be included in the computed results
 * @returns new total
 * @public
 */
function newTotal(type, measureOrId, attributeOrId, alias) {
    ts_invariant_1.default(type, "total type must be specified");
    ts_invariant_1.default(measureOrId, "measure or measure local id must be specified");
    ts_invariant_1.default(attributeOrId, "attribute or attribute local id must be specified");
    var measureIdentifier = measure_1.measureLocalId(measureOrId);
    var attributeIdentifier = attribute_1.attributeLocalId(attributeOrId);
    var aliasProp = alias ? { alias: alias } : {};
    return tslib_1.__assign({ type: type,
        measureIdentifier: measureIdentifier,
        attributeIdentifier: attributeIdentifier }, aliasProp);
}
exports.newTotal = newTotal;
/**
 * Tests whether total instance represents a native total = a roll-up total.
 *
 * @public
 */
function totalIsNative(total) {
    ts_invariant_1.default(total, "total must be specified");
    return total.type === "nat";
}
exports.totalIsNative = totalIsNative;
//# sourceMappingURL=totals.js.map